import { useEffect } from 'react';
import { storageManager } from '../utils/storageManager';

/**
 * Hook für globale Speicher-Überwachung
 * Startet automatisch den StorageManager und überwacht den Speicher
 */
export const useStorageManager = () => {
  useEffect(() => {
    // Initial-Check beim App-Start
    const stats = storageManager.getStorageStats();
    console.log('🚀 App gestartet - Speicher-Status:', {
      verwendet: `${(stats.used / 1024 / 1024).toFixed(2)} MB`,
      verfügbar: `${(stats.available / 1024 / 1024).toFixed(2)} MB`,
      prozent: `${stats.percentage.toFixed(1)}%`,
      status: stats.isCritical ? '🚨 Kritisch' : stats.isNearLimit ? '⚠️ Warnung' : '✅ OK'
    });

    // Führe bei App-Start eine Bereinigung durch, falls nötig
    if (stats.isNearLimit) {
      console.log('⚠️ App-Start: Führe präventive Speicher-Bereinigung durch');
      const cleanupResult = storageManager.checkAndCleanIfNeeded();
      if (cleanupResult && cleanupResult.savedBytes > 0) {
        console.log(`✅ ${(cleanupResult.savedBytes / 1024 / 1024).toFixed(2)} MB beim App-Start freigemacht`);
      }
    }

    // Der StorageManager startet bereits automatisch seine Überwachung
    // Keine weitere Einrichtung nötig
  }, []);

  return {
    getStorageStats: () => storageManager.getStorageStats(),
    forceCleanup: () => storageManager.forceCleanup(),
    logStorageInfo: () => storageManager.logStorageInfo()
  };
}; 